
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.732 15.41l-1.171-1.383.507-.43 3.742 3.735v.5l-3.742 3.734-.507-.43 1.164-1.366H3.639l1.164 1.367-.508.43-3.742-3.735v-.5l3.742-3.734.508.43L3.63 15.41h7.101zm.868 3.25l.867-1.078-.852-1.063H2.748l-.852 1.063.868 1.078H11.6z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"1.682","y":"26.066","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    